var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharacter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114.783,
    height: 114.783,
    viewBox: "0 0 114.783 114.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_27",
    x: 0,
    y: 0,
    width: 114.783,
    height: 114.783,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_89",
    "data-name": "Groupe 89",
    transform: "translate(-687.778 -134.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_88",
    "data-name": "Groupe 88",
    transform: "translate(695.273 139.203)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_298",
    "data-name": "Trac\\xE9 298",
    d: "M831.6,133.072a49.891,49.891,0,1,0-77.726,41.409l.033.222a17.077,17.077,0,0,0,5.658,3.6l.066-.222c2.357,2,12.169,5.21,23.474,5.186h.245c7.157,0,14.927-1.264,21.763-4.96,0,0,.061-.132.156-.377a17.775,17.775,0,0,0,4.715-3.22q.042-.288.08-.566A49.834,49.834,0,0,0,831.6,133.072Z",
    transform: "translate(-731.809 -83.182)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 687.78, 134.71)",
    filter: "url(#Ellipse_27)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27-2",
    "data-name": "Ellipse 27",
    cx: 48.391,
    cy: 48.391,
    rx: 48.391,
    ry: 48.391,
    transform: "translate(9 6)",
    fill: "var(--third-color)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_297",
    "data-name": "Trac\\xE9 297",
    d: "M788.342,231.22s-11.532.943-8.486,21.952a16.563,16.563,0,0,0,5.488,3.494l6.487-21.952Z",
    transform: "translate(-61.659 -22.222)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_298-2",
    "data-name": "Trac\\xE9 298",
    d: "M873.879,231.22s11.532.943,8.486,21.952a16.561,16.561,0,0,1-5.488,3.494l-6.487-21.952Z",
    transform: "translate(-109.78 -22.222)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_299",
    "data-name": "Trac\\xE9 299",
    d: "M789.976,158.2s-5.488,15.964-8.486,14.469c0,0,28.882,24.945,54.379,0A76,76,0,0,0,824.893,158.2Z",
    transform: "translate(-62.794 16.371)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 21.452,
    cy: 21.452,
    rx: 21.452,
    ry: 21.452,
    transform: "translate(724.241 151.625)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_300",
    "data-name": "Trac\\xE9 300",
    d: "M830.585,231.22h-37.4L789.676,246.2s-2.051,6.931.5,9.976,26.4,9.976,43.9.5a19.519,19.519,0,0,0,.5-12.47c-1.994-6.982-.5-.5-.5-.5Z",
    transform: "translate(-66.708 -22.222)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_301",
    "data-name": "Trac\\xE9 301",
    d: "M831.645,231.22H794.22L790.736,246.2s-2.051,6.931.5,9.976,26.4,9.976,43.9.5a19.518,19.518,0,0,0,.5-12.47c-1.994-6.982-.5-.5-.5-.5Z",
    transform: "translate(-67.269 -22.222)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_302",
    "data-name": "Trac\\xE9 302",
    d: "M831.045,231.22H793.629l-3.5,14.983s-2.051,6.931.5,9.976,26.4,9.976,43.9.5a19.519,19.519,0,0,0,.5-12.47c-1.994-6.982-.5-.5-.5-.5Z",
    transform: "translate(-66.946 -22.222)",
    fill: "var(--main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_303",
    "data-name": "Trac\\xE9 303",
    d: "M659.82,121.7h14.969v12.258a7.213,7.213,0,0,1-7.213,7.213h-.542a7.213,7.213,0,0,1-7.213-7.213Z",
    transform: "translate(78.334 74.884)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_304",
    "data-name": "Trac\\xE9 304",
    d: "M659.82,120.52h14.969v12.258a7.213,7.213,0,0,1-7.213,7.213h-.542a7.213,7.213,0,0,1-7.213-7.213V120.52Z",
    transform: "translate(78.334 75.508)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_305",
    "data-name": "Trac\\xE9 305",
    d: "M822.83,206.266a21.541,21.541,0,0,0,14.969.042V204.47H822.83Z",
    transform: "translate(-84.643 -8.084)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 21.452,
    cy: 21.452,
    rx: 21.452,
    ry: 21.452,
    transform: "translate(724.241 156.283)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_306",
    "data-name": "Trac\\xE9 306",
    d: "M795.25,130.232h40.9s-3.494-16.5-18.958-15.464S795.25,130.232,795.25,130.232Z",
    transform: "translate(-70.066 39.352)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 1.994,
    cy: 3.743,
    rx: 1.994,
    ry: 3.743,
    transform: "translate(722.689 173.077)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 1.994,
    cy: 3.743,
    rx: 1.994,
    ry: 3.743,
    transform: "translate(764.598 173.077)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_307",
    "data-name": "Trac\\xE9 307",
    d: "M795.25,131.412h40.9s-3.494-16.5-18.958-15.464S795.25,131.412,795.25,131.412Z",
    transform: "translate(-70.066 38.728)",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter);
export default __webpack_public_path__ + "static/media/character.1dce4f22.svg";
export { ForwardRef as ReactComponent };